module.exports = __webpack_public_path__ + "img/horizontal_6_2_8011.91785aba.png";